import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=b0543924&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=b0543924&prod&scoped=true&lang=css"
import style1 from "./ProductDetails.vue?vue&type=style&index=1&id=b0543924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0543924",
  null
  
)

export default component.exports